import { useDatabase } from "@nozbe/watermelondb/hooks";
import { useEffect, useState } from "react";
import { Card } from "@towersystems/roam-common-native";
import { FlatActionList } from "@towersystems/roam-common-native";
import FetchMeta from "../../../../utilities/data/model/FetchMeta";
import { ObservedLastSynced } from "./ObservedLastSynced";
import { ObservedSummaryCount } from "./ObservedSummaryCount";

export interface LocalDataSummaryCardProps {}

export const LocalDataSummaryCard = ({}: LocalDataSummaryCardProps) => {
  const [meta, setMeta] = useState<FetchMeta[] | undefined>(undefined);
  const database = useDatabase();

  useEffect(() => {
    database
      .get<FetchMeta>("fetch_meta")
      .query()
      .fetch()
      .then((i) => setMeta(i));
  }, []);

  const items =
    meta?.map((m) => ({
      key: m.id,
      title: m.id,
      subTitle: <ObservedSummaryCount fetchMeta={m} />,
      componentRight: () => <ObservedLastSynced fetchMeta={m} />,
    })) || [];

  return meta ? (
    <Card title="Last Synced">
      <FlatActionList items={items} />
    </Card>
  ) : null;
};
